import utilsArray from './src/array'
import utilsDate from './src/date'
import utilsDebounce from './src/debounce'
import utilsEncrypt from './src/encrypt'
import utilsNumber from './src/number'
import utilsReg from './src/reg'
import { fxRequestAnimationFrame, cancelAnimationFrame } from './src/requestAnimationFrame'
import utilsScroll from './src/scrollTop'
import utilsString from './src/string'
import utilsThrottle from './src/throttle'
import utilsType from './src/type'
import utilsFunc from './src/utils'
import { fxDataVerification } from './src/verification'

export default Object.assign(
	{ fxRequestAnimationFrame, cancelAnimationFrame, fxDataVerification },
	utilsArray,
	utilsDate,
	utilsDebounce,
	utilsEncrypt,
	utilsNumber,
	utilsReg,
	utilsScroll,
	utilsString,
	utilsThrottle,
	utilsType,
	utilsFunc
)



// WEBPACK FOOTER //
// ./src/lib/util/index.js